import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { ISettingsState, IIPMFile } from 'common/interfaces/settings';

// We currently store ipm files in settings ms
// that why api calls go to settings ms
// eventually they will be extracted to libraries ms
const settings = createSlice({
  name: 'ipm',
  initialState: {
    isLoading: true,
    data: [] as IIPMFile[],
    error: null,
  },
  reducers: {
    impFilesRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    impFilesReceived: (state, action: PayloadAction<IIPMFile[]>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    impFilesFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
});

export const {
  impFilesRequested,
  impFilesReceived,
  impFilesFailed,
} = settings.actions;

export default settings.reducer;

export const getIPMFilesData = () => apiCallBegan({
  url: '/settings/ipm-files',
  method: 'GET',
  onStart: impFilesRequested.type,
  onSuccess: (response: ISettingsState) => ({
    type: impFilesReceived.type,
    payload: response,
  }),
  onError: impFilesFailed.type,
});
